// extracted by mini-css-extract-plugin
export default {"shimmer":"ErrorText_shimmer__kWmY5","dark_shimmer":"ErrorText_dark_shimmer__OpUog","error_text":"ErrorText_error_text__KiAjy"};